import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useRegistrSVSeznamContext } from '@gov-nx/module/page';
import {
	Button,
	Dialog,
	DSGovFlex,
	FormCheckboxList,
	FormDatePicker,
	FormLegend,
	FormRadio,
	FormSelect,
	FormWidthElementLayout,
	LayoutGap,
} from '@gov-nx/ui/web';

export const FilterModal = () => {
	const {
		code,
		controls,
		isFilterWindowOpen,
		closeFilterModal,
		onReset,
		hasPFODataBox,
		typOsoby,
		dataBoxesPFO,
	} = useRegistrSVSeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();

	const tsn = getLocalizeCurried(code);

	return (
		<Dialog
			isOpen={isFilterWindowOpen}
			onClose={closeFilterModal}
			title={<h3>{tsn('formular.akce.filtrovat')}</h3>}
			footer={
				<>
					<Button
						onClick={onReset}
						color="primary"
						type="outlined"
						aria-label={tsn('formular.akce.zrusit')}
						size="m"
						isExpandedMobile>
						{tsn('formular.akce.zrusit-filtr')}
					</Button>
					<Button
						isLoading={controls.processLoading}
						aria-label={tsn('formular.akce.filtrovat')}
						name="submit"
						nativeType="submit"
						color="primary"
						size="m"
						type="solid"
						isExpandedMobile>
						{tsn('formular.akce.filtrovat')}
					</Button>
				</>
			}>
			<LayoutGap>
				<FormCheckboxList
					label={{
						children: tsn('formular.label.status'),
						size: 'xl',
						isLegend: true,
					}}
					control={{ fieldset: true }}
					group={{ gap: 's', orientation: 'horizontal' }}
					fields={[
						{
							name: 'filterStatus.provozovane',
							label: {
								children: tsn('formular.pole.filter-status-provozovane'),
							},
							size: 'm',
						},
						{
							name: 'filterStatus.zanik',
							label: { children: tsn('formular.pole.filter-status-zanik') },
							size: 'm',
						},
						{
							name: 'filterStatus.vse',
							label: { children: tsn('formular.pole.filter-status-vse') },
							size: 'm',
						},
					]}
				/>

				<fieldset>
					<LayoutGap gap="m">
						<FormLegend>{tsn('formular.label.obdobi')}</FormLegend>

						<DSGovFlex gap="l">
							<FormWidthElementLayout>
								<FormDatePicker
									field={{
										name: 'datumOd',
									}}
									label={{ children: tsn('formular.label.obdobi-od') }}
								/>
							</FormWidthElementLayout>
							<FormWidthElementLayout>
								<FormDatePicker
									field={{
										name: 'datumDo',
									}}
									label={{ children: tsn('formular.label.obdobi-do') }}
								/>
							</FormWidthElementLayout>
						</DSGovFlex>
					</LayoutGap>
				</fieldset>

				<FormCheckboxList
					label={{
						children: tsn('formular.label.vztah-k-vozidlu'),
						size: 'xl',
						isLegend: true,
					}}
					control={{ fieldset: true }}
					group={{ gap: 's', orientation: 'horizontal' }}
					fields={[
						{
							name: 'filterVztah.vlastnik',
							label: { children: tsn('formular.pole.filtr-vztah-vlastnik') },
							size: 'm',
						},
						{
							name: 'filterVztah.provozovatel',
							label: {
								children: tsn('formular.pole.filtr-vztah-provozovatel'),
							},
							size: 'm',
						},
						{
							name: 'filterVztah.vse',
							label: { children: tsn('formular.pole.filtr-vztah-vse') },
							size: 'm',
						},
					]}
				/>

				{hasPFODataBox && (
					<FormRadio
						field={{
							name: 'typOsoby',
							options: [
								{
									value: 'FO',
									label: {
										children: tsn('formular.pole.typ-osoby-fo'),
									},
								},
								{
									value: 'PFO',
									label: {
										children: tsn('formular.pole.typ-osoby-pfo'),
									},
									children:
										typOsoby === 'PFO' && dataBoxesPFO.length > 1 ? (
											<div>
												<FormSelect
													field={{
														name: 'ico',
														children: (
															<>
																{dataBoxesPFO.map((o) => (
																	<option
																		value={o.ico}
																		key={o.ico}>
																		{o.ico}
																	</option>
																))}
															</>
														),
													}}
													label={{ children: tsn('formular.pole.ico') }}
												/>
											</div>
										) : undefined,
								},
							],
						}}
						label={{
							children: tsn('formular.label.typOsoby'),
							size: 'xl',
							isLegend: true,
						}}
					/>
				)}
			</LayoutGap>
		</Dialog>
	);
};
